import { Component, ElementRef, inject, input, OnInit, output, signal, viewChild } from '@angular/core';
import { GaEventsService } from 'src/app/shared/services/ga-events.service';
import { UserInfo } from 'src/app/store/session/session.store';

@Component({
  selector: 'app-feature-announcement',
  standalone: true,
  templateUrl: './feature-announcement.component.html',
  styleUrls: ['./feature-announcement.component.scss'],
  imports: []
})
export class FeatureAnnouncementComponent implements OnInit {
  featureKey = input.required<string>();
  title = input.required<string>();
  description = input.required<string>();
  badgeText = input<string>('NOVIDADE');
  soundSrc = input<string>();
  dealerCnpj = input<string>();
  userInfo = input<UserInfo>();
  dismissed = output<void>();

  show = signal(false);

  private audioRef = viewChild<ElementRef<HTMLAudioElement>>('audioPlayer');

  private eventsService = inject(GaEventsService);

  ngOnInit() {
    const lastDismissed = localStorage.getItem(`announcement_${this.featureKey()}`);

    if (!lastDismissed || Date.now() - parseInt(lastDismissed, 10) > 24 * 60 * 60 * 1000) {
      setTimeout(() => {
        this.show.set(true);
        this.playSound();
      }, 800);
    }
  }

  goToWhatsApp(): void {
    this.eventsService.fireEvent('Floorplan', 'Clique', 'Novidade floorplan');
    const number = '5511947824368';
    const cnpj = this.dealerCnpj();
    const cnpjStr = cnpj ? ` do CNPJ ${cnpj}` : '';
    const message = `Olá, sou ${this.userInfo()?.name ?? ''}${cnpjStr}. Gostaria de saber mais sobre a linha de crédito de 90 dias do Auto Arremate.`;
    const url = `https://api.whatsapp.com/send?phone=${number}&text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  }

  dismiss() {
    this.show.set(false);
    localStorage.setItem(`announcement_${this.featureKey()}`, Date.now().toString());
    this.dismissed.emit();
  }

  private playSound() {
    const audio = this.audioRef()?.nativeElement;
    if (!audio) return;

    audio.currentTime = 0;
    audio.play().catch(() => {});
  }
}